import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box as Container } from '@primer/react';
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/1c9c6b81-0a2a-4a56-a9f5-a9608f89e220",
        "alt": "An image showing a group of labels with different styles, colors, leading icons and content."
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Use labels to indicate the status of an item or to help oraganize and categorize them. E.g, using "New" or "Recommended". Labels aren't meant to be used as interactive elements. Instead use the `}<a parentName="p" {...{
        "href": "/brand/components/Button"
      }}>{`Button`}</a>{` component.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/5da25ec0-a780-4add-972a-246bf9462e07" />
    <Caption mdxType="Caption">Use labels to categorize an item.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/976d645c-17ba-45ff-97ea-03c81a4c3b53" />
    <Caption mdxType="Caption">
      Don't use labels as an interactive or navigational element. Use a button
      or a link component.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Position the labels to clearly identify the object they’re informing.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/467449ad-013d-4b9c-9eec-a4655c4d13ec" />
    <Caption mdxType="Caption">
      Give labels enough space to be clearly identified. Use size or color to
      differentiate them if needed.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/5a32b608-2bc7-417b-b064-42c2308075ea" />
    <Caption mdxType="Caption">
      When used along with other items, don't place the label too close to them.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Content`}</h3>
    <p>{`Use Label with with short, scannable text. If possible, use a single word to describe the status of an object. Use two or more words if you need to describe a complex state or category. For example, “Limited availability" or "Enterprise only".`}</p>
    <h2>{`Options`}</h2>
    <h3>{`Size`}</h3>
    <p>{`Labels come in two sizes: `}<inlineCode parentName="p">{`medium`}</inlineCode>{`, and `}<inlineCode parentName="p">{`large`}</inlineCode>{`.`}</p>
    <h3>{`Medium`}</h3>
    <p>{`Use the `}<inlineCode parentName="p">{`medium`}</inlineCode>{` size when paired with medium-sized headings or in components such as `}<inlineCode parentName="p">{`Card`}</inlineCode>{`.`}</p>
    <Container display="grid" gridTemplateColumns={['1fr', null, null, null, '1fr 1fr']} gridGap={5} mdxType="Container">
  <div>
    <img src="https://github.com/primer/brand/assets/912236/2bca5ddd-2422-41a1-a32c-dc6be243f9ce" alt="" />
    <Caption mdxType="Caption">
      The Card component allows for a medium label to provide extra meta data to
      the content. In a group of stacked cards, the label helps to quickly scan
      certain items.
    </Caption>
  </div>
  <div>
    <img src="https://github.com/primer/brand/assets/6951037/c51e151c-d93a-42f8-bf73-6bd15b1c3781" alt="" />
    <Caption mdxType="Caption">
      Medium labels are great for headings that introduce a section. They help
      categorize the main topic and provide a visual break.
    </Caption>
  </div>
    </Container>
    <h3>{`Large`}</h3>
    <p>{`Use the `}<inlineCode parentName="p">{`large`}</inlineCode>{` size when paired with large headings, such as in the `}<inlineCode parentName="p">{`Hero`}</inlineCode>{` component.`}</p>
    <div>
  <img src="https://github.com/primer/brand/assets/6951037/13f9debc-3b20-4f77-a509-b8291ca677ae" alt="" />
  <Caption mdxType="Caption">
    Use large labels with headings that introduce a page. Use it to introduce
    the main topic or application.
  </Caption>
    </div>
    <h3>{`Color`}</h3>
    <p>{`The label offers color options from the `}<a parentName="p" {...{
        "href": "/brand/primitives/color"
      }}>{`Primer Brand color palette`}</a>{`. These color choices are carefully curated to ensure optimal contrast with the background or surrounding elements. Colors options doesn't follow a strict functional meaning. We recommend using the colors that best fit the context of your application. For example, blue and purple gradient for `}<inlineCode parentName="p">{`Copilot`}</inlineCode>{` examples.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/41817520-87bb-41bc-9586-95155604b83d",
        "alt": "An image showing multiple label options with different colors."
      }}></img></p>
    <h3>{`Leading visual`}</h3>
    <p>{`You can add a leading icon to enhance the visual context. It is recommended you use an `}<a parentName="p" {...{
        "href": "https://primer.style/octicons"
      }}>{`Octicon`}</a>{`. Use an icon that reinforces the meaning of the label. For example, a `}<inlineCode parentName="p">{`StarIcon`}</inlineCode>{` for a "Starred" label.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/d5fdf463-f5ce-4806-886d-1b8f44278308",
        "alt": "An image showing multiple label options with different leading visuals."
      }}></img></p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Button"
        }}>{`Button`}</a>{`: To provide an action.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Link"
        }}>{`Link`}</a>{`: To provide navigation.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      